import React from "react";
import MUIDataTable from "mui-datatables";

import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import { THEME_COLOR } from "./../../config/config";

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    display: "block",
    "@media (max-width: 960px)": {
      overflowX: "auto",
    },
  },
}));

const theme = createTheme({
  shadows: Array(5).fill("none"),
  overrides: {
    MUIDataTableHeadCell: {
      root: {
        zIndex: 0,
        padding: "12px 8px",
      },
      fixedHeader: {
        zIndex: 0,
      },
    },
    MuiTableCell: {
      root: {
        fontSize: "12px",
        padding: "8px",
        borderBottom: "1px solid #e0e0e0",
      },
      head: {
        fontWeight: "bold",
        fontSize: "12px",
        backgroundColor: "#f5f5f5",
        color: "#333",
      },
    },
    MuiPaper: {
      root: {
        width: "100%",
      },
    },
  },
  MuiFormLabel: {
    zIndex: 0,
  },
  MuiTableHead: { zIndex: 0 },
  palette: {
    primary: {
      main: THEME_COLOR,
    },
  },
});

export default function DataTable(props) {
  const classes = useStyles();

  let responsive = "standard";
  let tableBodyHeight = "100%";
  const options = {
    filter: true,
    responsive,
    tableBodyHeight,
    selectableRows: "none",
    rowsPerPage: 50,
    rowsPerPageOptions: [25, 50, 100],
    rowHover: true,
    // Allow a page to supply extra MUIDataTable options (e.g. columnOrder)
    // without changing the shared defaults above.
    ...(props.options || {}),
  };

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.tableWrapper}>
        <MUIDataTable
          title={props.title}
          data={props.tableData}
          columns={props.columns}
          options={options}
        />
      </div>
    </ThemeProvider>
  );
}
